// /src/services/videoConfigService.js
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

/**
 * Fetches video configuration from Firestore config collection
 * @param {string} docId - The document ID ('business_videos', 'education_videos', or 'insight_center_videos')
 * @returns {Promise<Object>} The video configuration data
 */
export async function fetchVideoConfig(docId) {
  try {
    const docRef = doc(db, "config", docId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.warn(`⚠️ Video config document '${docId}' not found`);
      return null;
    }
  } catch (error) {
    console.error(`❌ Error fetching video config '${docId}':`, error);
    throw error;
  }
}

/**
 * Fetches business videos configuration
 * @returns {Promise<Object>} Business videos data with faq, heroVideo, and sections
 */
export async function fetchBusinessVideos() {
  return fetchVideoConfig("business_videos");
}

/**
 * Fetches education videos configuration
 * @returns {Promise<Object>} Education videos data with faqGeneral, faqAnnuities, heroVideo, and sections
 */
export async function fetchEducationVideos() {
  return fetchVideoConfig("education_videos");
}

/**
 * Fetches insight center videos configuration
 * @returns {Promise<Object>} Insight center videos data with mainIntro and easterEgg
 */
export async function fetchInsightCenterVideos() {
  return fetchVideoConfig("insight_center_videos");
}

export default {
  fetchVideoConfig,
  fetchBusinessVideos,
  fetchEducationVideos,
  fetchInsightCenterVideos,
};
